<template>
  <div>
    <v-form ref="form">
    <div class="panel-heading d-flex">
      <h4 class="col-md-6 panel-title">{{ $t('mobileApp.homeBannerTitle') }}</h4>

      <div class="col-md-4">
        <div class="col-md-12 d-flex">

          <v-switch v-model="form.is_datetime" :label="$t('homeBanner.isCounterLabel')"></v-switch>
          <v-switch v-model="form.is_active" :label="$t('helpCenter.isActiveLabel')"></v-switch>
          <v-btn
            color="green"
            style="height: auto;color: white;"
            depressed
            @click="save"
          >
            {{ $t('common.save') }}
          </v-btn>
        </div>
      </div>
    </div>

    <div>
      <v-card style="margin: 10px;">
        <v-card-text>
            <div class="row">
              <div class="col-md-4">
                <v-text-field v-model="form.title" :label="$t('columns.title')" :rules="titleRules"></v-text-field>
              </div>
              <div class="col-md-4">
                <v-text-field v-model="form.title_ar" :label="$t('homeBanner.titleArabicLabel')" :rules="titleArRules"></v-text-field>
              </div>
              <div class="col-md-4">
                <v-text-field v-model="form.title_ku" :label="$t('homeBanner.titleKurdishLabel')" :rules="titleKuRules"></v-text-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label for="description" :style="{ color: descriptionError ? 'red' : 'inherit', opacity: descriptionError ? 1 : 0.8 }" style="font-size: 14px; margin-bottom: -8px">{{ $t('columns.description') }}</label>
                <textarea v-model="form.description" class="form-control" style="border-bottom: 1px solid blue; font-size: 1.5rem" rows="4"></textarea>
                <div v-if="descriptionError" class="error" style="color: red; font-size: 12px;">{{ descriptionError }}</div>
              </div>
              <div class="col-md-4">
                <label for="description_ar" :style="{ color: descriptionArError ? 'red' : 'inherit', opacity: descriptionArError ? 1 : 0.8 }" style="font-size: 14px; margin-bottom: -8px">{{ $t('homeBanner.descriptionArabicLabel') }}</label>
                <textarea v-model="form.description_ar" class="form-control" style="border-bottom: 1px solid blue; font-size: 1.5rem" rows="4"></textarea>
                <div v-if="descriptionArError" class="error" style="color: red; font-size: 12px;">{{ descriptionArError }}</div>
              </div>
              <div class="col-md-4">
                <label for="description_ku" :style="{ color: descriptionKuError ? 'red' : 'inherit', opacity: descriptionKuError ? 1 : 0.8 }" style="font-size: 14px; margin-bottom: -8px">{{ $t('homeBanner.descriptionKurdishLabel') }}</label>
                <textarea v-model="form.description_ku" class="form-control" style="border-bottom: 1px solid blue; font-size: 1.5rem" rows="4"></textarea>
                <div v-if="descriptionKuError" class="error" style="color: red; font-size: 12px;">{{ descriptionKuError }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <v-text-field v-model="form.start_date" :label="$t('homeBanner.startDateLabel')" type="datetime-local" :rules="startDateRules"></v-text-field>
              </div>
              <div class="col-md-6">
                <v-text-field v-model="form.end_date" :label="$t('homeBanner.endDateLabel')" type="datetime-local" :rules="endDateRules"></v-text-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <v-text-field v-model="form.color" :label="$t('customer.color')" type="color" :rules="colorRules"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-text-field v-model="form.color_dark" :label="$t('homeBanner.colorDarkLabel')" type="color" :rules="colorRules"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-text-field v-model="form.bgcolor" :label="$t('homeBanner.backgroundColorLabel')" type="color" :rules="colorRules"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-text-field v-model="form.bgcolor_dark" :label="$t('homeBanner.backgroundColorDarkLabel')" type="color" :rules="colorRules"></v-text-field>
              </div>
            </div>
        </v-card-text>
      </v-card>
    </div>
    </v-form>
  </div>
</template>

<script>
import Axios from 'axios'

export default {
  data() {
    return {
      url: 'api/home-banner',
      form: {
        home_banners_id: null,
        title: '',
        title_ar: '',
        title_ku: '',
        description: '',
        description_ar: '',
        description_ku: '',
        start_date: null,
        end_date: null,
        is_active: true,
        color: '#000000',
        bgcolor: '#000000',
        color_dark: '#000000',
        bgcolor_dark: '#000000'
      },
      descriptionError: '',
      descriptionArError: '',
      descriptionKuError: '',
      titleRules: [v => !!v || this.$t('homeBanner.titleRequiredError')],
      titleArRules: [v => !!v || this.$t('homeBanner.titleArabicRequiredError')],
      titleKuRules: [v => !!v || this.$t('homeBanner.titleKurdishRequiredError')],
      startDateRules: [v => !!v || this.$t('homeBanner.startDateRequiredError')],
      endDateRules: [
        v => !!v || this.$t('homeBanner.endDateRequiredError'),
        v => !this.form.start_date || new Date(v) > new Date(this.form.start_date) || this.$t('homeBanner.endDateAfterStartDateError')
      ],
      colorRules: [v => /^#[0-9A-F]{6}$/i.test(v) || this.$t('homeBanner.colorHexError')]
    }
  },

  mounted() {
    this.getData()
  },

  methods: {
    getData() {
      var token = localStorage.getItem('access_token')

      Axios.get(this.url, { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        const data = res.data.data
        if (data) {
          // Format dates for datetime-local inputs
          if (data.start_date) {
            data.start_date = this.formatDateForInput(data.start_date)
          }
          if (data.end_date) {
            data.end_date = this.formatDateForInput(data.end_date)
          }
          this.form = data
        }
      })
    },

    save() {
      // Reset errors
      this.descriptionError = ''
      this.descriptionArError = ''
      this.descriptionKuError = ''

      let isValid = this.$refs.form.validate()

      if (!this.form.description.trim()) {
        this.descriptionError = this.$t('homeBanner.descriptionRequiredError')
        isValid = false
      }
      if (!this.form.description_ar.trim()) {
        this.descriptionArError = this.$t('homeBanner.descriptionArabicRequiredError')
        isValid = false
      }
      if (!this.form.description_ku.trim()) {
        this.descriptionKuError = this.$t('homeBanner.descriptionKurdishRequiredError')
        isValid = false
      }

      if (!isValid) {
        return
      }
      this.update()
    },

    update() {
      var token = localStorage.getItem('access_token')
      Axios.post(this.url, this.form, { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        this.getData()
        swal({
          title: this.$t('common.done'),
          text: '',
          icon: 'success',
          timer: 500,
          buttons: false
        })
      }).catch(err => {
        console.error('Error response:', err.response)
      })
    },

    formatDateForInput(dateString) {
      if (!dateString) return null
      // Convert ISO string to datetime-local format (YYYY-MM-DDTHH:MM)
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day}T${hours}:${minutes}`
    }
  }
}
</script>

<style>
.switchbutton .input-group__details {
  min-height: 0px !important;
}
.switchbutton {
  margin-top: 10px !important;
}
.error {
  background-color: #fff !important;
  border-color: #fff !important
}
.input-group__details {
  min-height: 0px !important;
}
.switch {
  margin-top: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homeBanner/homeBanner.vue